import { GridFooterCellProps } from "@progress/kendo-react-grid";
import { useTheme } from "@mui/material";
import { StopDataFooterProps } from "./StopDataFooterProps";
import { colorShade } from "../../../../../../Layout/Grid/Cell/KendoReactColoredFooterCell";

export default function StopDataKmSumCell({
  routings,
  colSpan,
}: StopDataFooterProps & GridFooterCellProps) {
  const theme = useTheme();
  const total = routings.reduce((acc, current) => acc + (current.Km || 0), 0);
  return (
    <td colSpan={colSpan} style={{ backgroundColor: theme.palette.grey[colorShade] }}>
      {total}
    </td>
  );
}
